import type { ReactNode } from "react"

/** A section below the fold: a small caps label, a serif heading, then the body, on a hairline. */
export function NlSection({ id, eyebrow, title, className, children }: { id: string; eyebrow: string; title: string; className?: string; children: ReactNode }) {
  return (
    <section id={id} className={`nl-section${className ? ` ${className}` : ""}`} aria-labelledby={`${id}-h`}>
      <p className="nl-eyebrow">{eyebrow}</p>
      <h2 id={`${id}-h`} className="nl-h2">{title}</h2>
      {children}
    </section>
  )
}
